import React from "react";
import { Github, Linkedin, Whatsapp, Heart } from "./Icons";

const SOCIAL = [
  { href: "https://github.com/brgomesz", label: "GitHub", Icon: Github },
  {
    href: "https://www.linkedin.com/in/bruno-rodrigues-609146181/",
    label: "LinkedIn",
    Icon: Linkedin,
  },
  {
    href: "https://api.whatsapp.com/send/?phone=5547999284866",
    label: "WhatsApp",
    Icon: Whatsapp,
  },
];

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-inner">
          <div className="footer-brand">
            <h3>Bruno Rodrigues</h3>
            <p>
              Desenvolvedor Full-stack focado em produtos de dados, automação e
              IA aplicada — do banco de dados à interface, com olhar de produto.
            </p>
          </div>
          <div className="footer-social">
            <h4>Redes</h4>
            <div className="social-row">
              {SOCIAL.map(({ href, label, Icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  className="social-btn"
                  aria-label={label}
                  title={label}
                >
                  <Icon />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} Bruno Rodrigues</span>
          <span className="made">
            Feito com <Heart /> e muito código
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
